import { cn } from '../../../lib/utils';

export const AssetIcon = ({
  symbol,
  className,
}: { symbol: string; className?: string }) => {
  const symbolFirstThreeLetters = symbol.slice(0, 3);
  return (
    <div
      className={cn(
        'bitte-rounded-full bitte-bg-[#627eea] bitte-flex bitte-items-center bitte-justify-center',
        className,
      )}
    >
      <span className="bitte-text-white bitte-font-semibold bitte-text-[10px]">
        {symbolFirstThreeLetters}
      </span>
    </div>
  );
};
